<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pd98HP/tc-custom/9781454711018.jpg?1712927282512" alt="This image is the cover for the book Simply Shetland Lace"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Simply Shetland Lace
      </h1>
      <p class="bookDescription body article font2">
        <b>Learn how to master three classic Shetland lace motifs—just six simple stitches—and build your skills with twenty beautiful and varied projects, too.</b><br/><br/> <br/><br/>Explore traditional Shetland lace knitting with expert teacher Brooke Nico! She shows how just three simple motifs—Feather and Fan and Old Shale; Acre and Razor; and Horseshoe and Leaf—can yield a variety of lovely items, from fashion, to accessories, to home décor. Step-by-step photos and easy-to-follow instructions help even beginners grasp each stitch, and the projects grow progressively more difficult as knitters become more comfortable with the techniques.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brooke Nico
      </h2>
      
      <p class="authorDescription body article">Brooke Nico lives in Kirkwood, MO, where she cofounded the yarn shop Kirkwood Knittery. Brooke teaches at knitting events around the country, and her books include Lovely Knitted Lace and More Lovely Knitted Lace; her work has also appeared in severalknitting collections. FindBrooke’s designs online at kirkwoodknittery.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?31b803ee